import { overlayRootStyles } from './overlayRootStyles';

export const summerOverlayStyles = `
  ${overlayRootStyles}

  @import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap');

  @keyframes sp-sunrise-glow {
    0%, 100% { box-shadow: 5px 5px 0 #0077b6, 0 0 16px rgba(255, 107, 53, 0.35); }
    50%      { box-shadow: 5px 5px 0 #0077b6, 0 0 30px rgba(255, 200, 90, 0.60); }
  }

  @keyframes sp-border-rise {
    0%   { background-position: 0 0; }
    100% { background-position: 0 200%; }
  }

  .summer-overlay-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: transparent;
    font-family: 'Press Start 2P', 'JetBrains Mono', monospace;
    -webkit-font-smoothing: none;
    image-rendering: pixelated;
    color: #fff8e7;
  }

  .summer-bottom-panel {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 160px;
    z-index: 10;
    box-sizing: border-box;
    background-color: #ff6b35;
    background-image:
      repeating-linear-gradient(0deg, rgba(0, 119, 182, 0.5) 0px, rgba(0, 119, 182, 0.5) 16px, transparent 16px, transparent 64px),
      repeating-linear-gradient(0deg, rgba(255, 230, 109, 0.6) 32px, rgba(255, 230, 109, 0.6) 48px, transparent 48px, transparent 64px),
      repeating-linear-gradient(90deg, rgba(0, 180, 216, 0.45) 0px, rgba(0, 180, 216, 0.45) 16px, transparent 16px, transparent 64px),
      repeating-linear-gradient(90deg, rgba(255, 230, 109, 0.5) 32px, rgba(255, 230, 109, 0.5) 48px, transparent 48px, transparent 64px);
    box-shadow: inset 0 6px 0 rgba(0, 119, 182, 0.45);
  }

  .summer-stitch-top {
    position: absolute;
    top: -4px;
    left: 0;
    right: 0;
    height: 8px;
    background: repeating-linear-gradient(90deg, #ffe66d 0px, #ffe66d 8px, transparent 8px, transparent 16px);
    z-index: 5;
  }

  .widget-row {
    position: relative;
    z-index: 2;
    display: flex;
    flex-wrap: nowrap;
    gap: 18px;
    padding: 26px 28px;
    padding-right: 700px;
    align-items: stretch;
    justify-content: space-between;
    height: 100%;
    box-sizing: border-box;
  }

  .summer-widget {
    background: rgba(0, 119, 182, 0.92);
    border: 4px solid #ffe66d;
    border-radius: 0;
    padding: 14px 18px;
    box-shadow: 4px 4px 0 #0077b6, inset 0 0 0 1px rgba(255, 230, 109, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 93px;
    overflow: hidden;
    box-sizing: border-box;
  }

  .widget-timer {
    flex: 1.5;
    min-width: 0;
  }

  .widget-kanban {
    flex: 3.5;
    min-width: 0;
  }

  .widget-rotating {
    flex: 5;
    min-width: 0;
  }

  .overlay-chat {
    position: absolute;
    right: 16px;
    z-index: 50;
    width: 640px;
    height: 225px;
    box-sizing: border-box;
  }

  .overlay-chat--above-camera {
    bottom: 389px;
  }

  .overlay-chat--bottom {
    bottom: 16px;
  }

  .chat-pixel-border {
    width: 100%;
    height: 100%;
    padding: 6px;
    box-sizing: border-box;
    background: linear-gradient(180deg,
      #0077b6 0%,
      #00b4d8 12%,
      #ff9e64 25%,
      #ff6b35 38%,
      #ffe66d 50%,
      #ff6b35 62%,
      #ff9e64 75%,
      #00b4d8 88%,
      #0077b6 100%);
    background-size: 100% 200%;
    animation:
      sp-sunrise-glow 4.5s ease-in-out infinite,
      sp-border-rise 28s linear infinite;
  }

  .chat-window {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border: 3px solid #0077b6;
    background: #08263a;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .chat-dock-area {
    flex: 1;
    min-height: 0;
  }

  .overlay-camera {
    position: absolute;
    bottom: 16px;
    right: 16px;
    z-index: 50;
    width: 640px;
    height: 360px;
    box-sizing: border-box;
  }

  .camera-pixel-border {
    width: 100%;
    height: 100%;
    padding: 6px;
    box-sizing: border-box;
    background: linear-gradient(180deg,
      #0077b6 0%,
      #00b4d8 12%,
      #ff9e64 25%,
      #ff6b35 38%,
      #ffe66d 50%,
      #ff6b35 62%,
      #ff9e64 75%,
      #00b4d8 88%,
      #0077b6 100%);
    background-size: 100% 200%;
    animation:
      sp-sunrise-glow 4.5s ease-in-out infinite,
      sp-border-rise 28s linear infinite;
  }

  .camera-window {
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border: 3px solid #0077b6;
    background: #08263a;
    overflow: hidden;
  }

  /* Widget text overrides */
  .summer-widget .timer-flannel-label,
  .summer-widget .kanban-flannel-label {
    color: #ffe66d !important;
    text-shadow: 1px 1px 0 #0077b6;
  }

  .summer-widget .timer-flannel-value,
  .summer-widget .kanban-flannel-value {
    color: #fff8e7 !important;
    text-shadow: 2px 2px 0 #ff6b35;
  }

  .summer-widget .kanban-flannel-value {
    text-shadow: 1px 1px 0 #ff6b35;
  }

  .summer-widget .timer-flannel-value.expired {
    color: #ff9e64 !important;
  }

  .summer-widget .timer-flannel-value.paused {
    color: #ffe66d !important;
  }

  .summer-widget .timer-flannel-loading {
    color: #ffe66d !important;
  }

  /* Rotating stats summer overrides */
  .summer-overlay-container .rotating-panel-loading {
    color: #ffe66d;
  }

  .summer-overlay-container .rotating-widget-label {
    text-shadow: 1px 1px 0 #0077b6;
  }

  .summer-overlay-container .rotating-widget-value {
    font-size: 0.8rem;
  }

  .summer-overlay-container .rotating-widget-extra {
    text-shadow: 1px 1px 0 #0077b6;
  }

  .summer-overlay-container .rotating-progress-bar {
    background: rgba(8, 38, 58, 0.55);
    border-color: rgba(255, 230, 109, 0.5);
  }

  .summer-overlay-container .rotating-dot {
    background: rgba(0, 180, 216, 0.4);
  }

  .summer-overlay-container .rotating-dot.active {
    background: #00b4d8;
    box-shadow: 0 0 4px rgba(0, 180, 216, 0.6);
  }
`;
